import { render, staticRenderFns } from "./dateReport.vue?vue&type=template&id=70567175&scoped=true"
import script from "./dateReport.vue?vue&type=script&lang=js"
export * from "./dateReport.vue?vue&type=script&lang=js"
import style0 from "./dateReport.vue?vue&type=style&index=0&id=70567175&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70567175",
  null
  
)

export default component.exports